var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_949_9340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48318 4.22971L1.88351 10.8294C1.62316 11.0897 1.62316 11.5118 1.88351 11.7722C2.14386 12.0325 2.56597 12.0325 2.82632 11.7722L9.42599 5.17252C9.68634 4.91217 9.68634 4.49006 9.42599 4.22971C9.16564 3.96936 8.74353 3.96936 8.48318 4.22971Z",
    fill: "#ffffff",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.42654 10.8289L2.82687 4.22922C2.56652 3.96887 2.14441 3.96887 1.88406 4.22922C1.62371 4.48957 1.62371 4.91168 1.88406 5.17203L8.48373 11.7717C8.74408 12.032 9.16619 12.032 9.42654 11.7717C9.68689 11.5113 9.68689 11.0892 9.42654 10.8289Z",
    fill: "#ffffff",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_949_9340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8966,
    height: 16,
    fill: "black",
    transform: "translate(0.654297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose2);
export default __webpack_public_path__ + "static/media/ic-close2.a3535f28b23f3cead93a929db19d7a50.svg";
export { ForwardRef as ReactComponent };